<template>
  <button
    v-if="menu.actionType"
    class="sidebar-v2-item sidebar-v2-item--button"
    type="button"
    :data-testid="`side-menu-${menu.menuName}`"
    @click="onClickMenuItem"
  >
    <span class="sidebar-v2-item__left">
      <WCSvgIcon class="sidebar-v2-item__icon" :name="menu.menuIcon" icon-size="lg" />
      <span class="sidebar-v2-item__label">
        {{ menu.menuName }}
      </span>
    </span>
    <font-awesome-icon
      class="sidebar-v2-item__chevron"
      icon="chevron-right"
      v-show="isDisplayChevronRight"
    />
  </button>
  <router-link
    v-else
    :to="menu.menuRoute"
    class="sidebar-v2-item"
    :data-testid="`side-menu-${menu.menuName}`"
    @click="onClickMenuItem"
  >
    <span class="sidebar-v2-item__left">
      <WCSvgIcon class="sidebar-v2-item__icon" :name="menu.menuIcon" icon-size="lg" />
      <span class="sidebar-v2-item__label">
        {{ menu.menuName }}
      </span>
    </span>
    <font-awesome-icon
      class="sidebar-v2-item__chevron"
      icon="chevron-right"
      v-show="isDisplayChevronRight"
    />
  </router-link>
</template>

<script>
import WCSvgIcon from '../../../../components/WCSvgIcon/WCSvgIcon.vue';
import SideMenuService from '../../services/SideMenuService';

export default {
  emits: ['menu-action'],
  components: {
    WCSvgIcon,
  },
  props: {
    menu: {
      type: Object,
      required: true,
    },
    isDisplayChevronRight: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onClickMenuItem() {
      if (this.menu.actionType) {
        this.$emit('menu-action', this.menu);
      }
      SideMenuService.close();
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.sidebar-v2-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: var(--dark, $dark);
  text-decoration: none;
}

.sidebar-v2-item--button {
  border: 0;
  background: transparent;
  text-align: left;
  padding: 0;
}

.sidebar-v2-item__left {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  gap: 0.75rem;
}

.sidebar-v2-item__icon {
  color: var(--primary, $primary);
  width: 1rem;
}

.sidebar-v2-item__label {
  color: var(--dark, $dark);
  font-size: 1rem;
  line-height: 1.2;
}

.sidebar-v2-item__chevron {
  color: var(--dark-lighter-5);
  width: 0.9rem;
  flex-shrink: 0;
}
</style>
